import { useState } from 'react';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Button } from '@optimus-web/core';
import ReservationConfirmationDialog from './ReservationConfirmationDialog';

interface Props {
    reservationId: string;
    onUpdate: () => void;
}

const ReservationConfirmationAction = ({ reservationId, onUpdate }: Props) => {
    const [activeDialog, setActiveDialog] = useState<boolean>(false);

    const onClick = () => setActiveDialog(true);
    const onClose = () => setActiveDialog(false);

    const onSuccess = () => {
        onUpdate();
        onClose();
    };

    return (
        <>
            <Button
                variant="primary"
                onClick={onClick}
                data-test-reservation-confirmation={reservationId}
                type="submit"
            >
                <LocalizedText textKey={TextKey.Confirm} />
            </Button>
            <ReservationConfirmationDialog
                active={activeDialog}
                closeDialog={onClose}
                reservationIds={[reservationId]}
                onSuccess={onSuccess}
            />
        </>
    );
};

export default ReservationConfirmationAction;
